var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parentMessageBox"},[_c('div',{staticClass:"content"},[(Array.isArray(_vm.form))?_c('NoContent'):(this.form!=null)?_c('parentMessage',{attrs:{"form":_vm.form}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }